export default "__VITE_ASSET__BJu78KIk__"